import PropTypes from 'prop-types'
import styles from './BordePrincipal.module.css'

const BordePrincipal = (props) => {
  return (
    <fieldset className={`fieldset ${styles.borde} ${props.className || ''}`}>
      <legend className={styles.titulo}>{props.titulo}</legend>
      <div className={styles.contenido}>{props.children}</div>
    </fieldset>
  )
}

BordePrincipal.propTypes = {
  titulo: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
}

export default BordePrincipal
